module.exports = __webpack_public_path__ + "img/btn_menu_allt_c.aa68e05c.png";